
<template>
  <div>
    <div>
      <h4 style="margin-top:20px">Filter</h4>
    </div>
    <div
      style="background: rgb(238,239,242); height: 100%; width: 100%; margin-top: 0px;font-family: 'Poppins', sans-serif;"
      class="keyword">
      <div style="display: flex; justify-content: space-around; margin-top:0px;">
        <div class="box">
          <p>Portfolio</p>
          <!-- <span class="arrow"></span> -->
          <input type="text" name="" class="keywordandproduct" :label="portfolio" v-model="portfoliovalue" disabled>
          <!-- <q-page>
          <q-input :label="portfolio" v-model="portfoliovalue" placeholder="Enter text here" style="background-color:rgb(255,255,255)!important ; width:300px; height:40px; border-radius:10px;"/>
        </q-page> -->

        </div>
        <div class="box">
          <p ref="campaignLabel">Campaign</p>
          <div id="dropdown-anchor"></div>
          <q-btn-dropdown class="keywordandproduct" :label="selectedCampaign" v-model="campaignvalue"
            style="background-color:rgb(255,255,255)!important ;" flip prevent-overlap @show="positionDropdown">
            <q-scroll style="max-width: 200px;">
              <q-input v-model="searchQuery" filled dense debounce="100" v-slot:prepend class="q-pa-sm"
                placeholder="Search Campaign" style="min-width: 200px" />
              <q-list class="campaign-dropdown-list"
                style="background-color: rgb(255,255,255); max-height: 200px; overflow-y: auto;">
                <q-item v-for="campaign in getCampaignItems" :key="campaign" clickable v-close-popup
                  @click="onCampaignSelect(campaign)">
                  <q-item-section>
                    <q-item-label>{{ campaign }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-scroll>
          </q-btn-dropdown>


          <!-- <q-btn-dropdown class="col q-mr-sm q-mt-lg" :label="campaign_list">
              <q-list>
                <q-item clickable v-for="list in campaignlist" :key="list" v-close-popup @click="setCampaignName(item)">
                  <q-item-section>
                    <q-item-label>{{ list }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown> -->
        </div>
        <div class="box">
          <p>Ad Group</p>
          <q-btn-dropdown class="keywordandproduct" :label="selectedAdgroup" v-model="advalue"
            style="background-color:rgb(255,255,255) !important ;">
            <q-input v-model="searchQuery1" filled dense debounce="300" v-slot:prepend class="q-pa-sm"
              placeholder="Search Adgroup" style="min-width: 200px" />
            <q-list>
              <q-item v-for="adgroups in getAdgroupItems" :key="adgroups" clickable v-close-popup
                @click="onAdgroupSelect(adgroups)">
                <q-item-section>
                  <q-item-label>{{ adgroups }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </div>
      </div>
      <div
        class="input-row"
        style="display: flex; justify-content: space-around; margin-top: 0"
      >
        <div class="box">
          <p>Targeting</p>
          <!-- <span class="arrow"></span> -->
          <q-btn-dropdown class="dropdown-buttons" :label="targetselector" v-model="Targetingvalue" style="background-color: rgb(255,255,255)!important; width: 300px; height:40px; border-radius: 10px;  overflow:hidden;">
              <q-list>
                <q-item clickable v-for="targetitem in targetting" :key="item" v-close-popup @click="onTargetting(targetitem)">
                  <q-item-section>
                    <q-item-label >{{ targetitem }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          <!-- <select :label="Targeting" >
            <option value="select" selected>Select</option>
            <option value="option1">BROAD</option>
            <option value="option2">EXACT</option>
            <option value="option3">PHRASE</option>
            <option value="option4">TARGETING_EXPRESSION</option>
            <option value="option5">TARGETING_EXPRESSION_PREDEFINED</option>
          </select> -->
        </div>
        <div class="box">
          <p>Keyword Search</p>
          <input type="text" name="" class="keywordandproduct" v-model="keywordsearchvalue" disabled>
        </div>
        <div class="box">
          <p>Product ASIN</p>
          <input type="text" name="" class="keywordandproduct" v-model="productasinvalue" disabled>
        </div>
      </div>
      <div class="input-row" style="display: flex; justify-content: space-around; ">
        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="input1">
              <p>Campaign Type</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="campaigntypeselector" v-model="campaigntypevalue"
                style="background-color: rgb(255,255,255)!important; width: 170px; height:40px; border-radius: 10px; overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="campaignitems in campaigntype" :key="list" v-close-popup
                    @click="oncampaigntype(campaignitems)">
                    <q-item-section>
                      <q-item-label class="custom-overflow">{{ campaignitems }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input2">
              <p>State</p>
              <q-btn-dropdown class="dropdown-buttons" :label="statetype" v-model="statetypevalue"
                style="background-color: rgb(255,255,255)!important; width: 100px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="stateitems in state" :key="list" v-close-popup @click="onstate(stateitems)">
                    <q-item-section>
                      <q-item-label class="custom-overflow">{{ stateitems }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
          </div>
        </div>
        <div class="box">
          <p>Date Range</p>
          <div class="dateDropDown col-3" style="align-items: flex-end!important; display:flex!important;">
            <q-input v-model="dateValuecalendar" filled dense :placeholder="getCurrentMonthFormatted()"
              style="background-color: rgb(255,255,255) !important; flex: 1; border-radius: 10px; margin-right: 20px;">
              <template v-slot:append>
                <div class="q-if-row q-gutter-md items-center justify-between" style="width:100%;">

                  <q-popup-proxy cover transition-show="scale" transition-hide="scale" ref="qStartDateProxy">
                    <q-date v-model="dateRange" ref="myQDate" :options="optionsFn" range @input="closeStartDateCalendar">
                    </q-date>
                  </q-popup-proxy>
                  <q-icon name="event" class="cursor-pointer" style="justify-content:right!important; margin-left: 10px">
                  </q-icon>
                </div>
              </template>
            </q-input>
          </div>
        </div>


        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="input-roas">
              <p>Sales</p>
              <!-- <span class="arrow"></span> -->
              <!-- <select>
                  <option value="option1">Select</option>
                  <option value="option2">></option>
                  <option value="option3"><</option>
                  <option value="option4">=</option>
              </select> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator in operators" :key="list" v-close-popup @click="onOperator(operator)">
                    <q-item-section>
                      <q-item-label>{{ operator }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptyclicks1">
              <input type="number" class="input-field-doublebox" v-model="value">
            </div>
          </div>
        </div>
      </div>
      <div class="input-row" style="display: flex; justify-content: space-around;">
        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="input-campaigntype">
              <p>Cost</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator1"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator1 in operators" :key="list" v-close-popup
                    @click="onOperator1(operator1)">
                    <q-item-section>
                      <q-item-label>{{ operator1 }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptycampaigntypes">
              <p class="empty"></p>
              <input type="number" class="input-field-doublebox" v-model="value1">
            </div>
          </div>
        </div>
        <div class="box boxdouble">
          <div class="box-boxdouble1" style="width:300px;">
            <div class="input-cost">
              <p>CTR</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator2"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator2 in operators" :key="list" v-close-popup
                    @click="onOperator2(operator2)">
                    <q-item-section>
                      <q-item-label>{{ operator2 }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptycampaigntype">
              <!-- <p class="empty">empty data</p> -->
              <input type="number" class="input-field-doublebox" v-model="ctrvalue">
            </div>
          </div>
        </div>
        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="input-impression">
              <p>CVR</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator3"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator3 in operators" :key="list" v-close-popup
                    @click="onOperator3(operator3)">
                    <q-item-section>
                      <q-item-label>{{ operator3 }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptycampaigntype">
              <!-- <p class="empty">empty data</p> -->
              <input type="number" class="input-field-doublebox" v-model="cvrvalue">
            </div>
          </div>
        </div>
      </div>
      <div class="input-row" style="display: flex; justify-content: space-around;">
        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="input-clicks">
              <p>Clicks</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator4"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator4 in operators" :key="list" v-close-popup
                    @click="onOperator4(operator4)">
                    <q-item-section>
                      <q-item-label>{{ operator4 }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptyclicks">
              <!-- <p class="empty">empty data</p> -->
              <input type="number" class="input-field-doublebox" v-model="clicksvalue">
            </div>
          </div>
        </div>
        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="Roas">
              <p>ROAS</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator5"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator5 in operators" :key="list" v-close-popup
                    @click="onOperator5(operator5)">
                    <q-item-section>
                      <q-item-label>{{ operator5 }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptyclicks-acos">
              <!-- <p>ACOS</p> -->
              <input type="number" class="input-field-doublebox" v-model="roasvalue">
            </div>
          </div>
        </div>
        <div class="box boxdouble">
          <div class="box-boxdouble1">
            <div class="input-ctr">
              <p>Orders</p>
              <!-- <span class="arrow"></span> -->
              <q-btn-dropdown class="dropdown-buttons" :label="selectedoperator6"
                style="background-color: rgb(255,255,255)!important; width: 130px; height:40px; border-radius: 10px;overflow:hidden;">
                <q-list>
                  <q-item clickable v-for="operator6 in operators" :key="list" v-close-popup
                    @click="onOperator6(operator6)">
                    <q-item-section>
                      <q-item-label>{{ operator6 }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
            <div class="input-emptyclicks">
              <!-- <p class="empty" style="display: none;">empty data</p> -->
              <input type="number" class="input-field-doublebox" v-model="ordervalue">
            </div>
          </div>
        </div>
      </div>
      ​
      <div style="
          margin-top: 5px;
          padding-inline: 67px;
          display: flex;
          justify-content: end;
          gap: 14px;
          margin-bottom: 20px;
        ">
        <button class="button-grup" style=" margin-bottom: 30px; background-color: red;"
          @click="clearButtonClicked">Clear</button>
        <button class="button-grup-red" style=" margin-bottom: 30px; background-color: rgb(16,38,137);"
          @click="applycall">Apply</button>
      </div>
    </div>
    <div class="box boxdouble" style="background-color: rgb(244,247,252);">
      <div class="box-boxdouble1">
        <div class="input-emptyclicks1" style="background-color: rgb(244,247,252);">
          <!-- <span class="arrow"></span> -->
          <q-btn-dropdown class="dropdown-buttons" :label="negativematchtype"
            style="background-color: rgb(255,255,255)!important; width: 300px; height:40px; border-radius: 10px; overflow: hidden; ">
            <q-list>
              <q-item clickable v-for="Negative in negativematch" :key="list" v-close-popup
                @click="onnegativetype(Negative)">
                <q-item-section>
                  <q-item-label>{{ Negative }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>

          <!-- <select>
                  <option value="" selected>Negative Match Type</option>
                  <option value="option1">NEGATIVE_EXACT</option>
                  <option value="option2">NEGATIVE_PHRASE</option>
                  <option value="option3">NEGATIVE_BROAD</option>
              </select> -->
        </div>
        <div class="input-emptyclicks2">
          <q-btn-dropdown class="keywordandproduct" :label="selectedCampaign1" v-model="negativecmpaign"
            style="background-color:rgb(255,255,255)!important ;" @focus="handleDropdownFocus" @blur="handleDropdownBlur"
            flip prevent-overlap @show="positionDropdown">
            <q-input v-model="searchQuery2" filled dense debounce="300" v-slot:prepend class="q-pa-sm"
              placeholder="Search Campaign" style="min-width: 200px" />
            <q-list class="campaign-dropdown-list"
              style="background-color: rgb(255,255,255); max-height: 200px; overflow-y: auto;">
              <q-item v-for="campaign1 in getemailbasednegativecampaign" :key="campaign1" clickable v-close-popup
                @click="onCampaignSelect1(campaign1)">
                <q-item-section>
                  <q-item-label>{{ campaign1 }}</q-item-label>
                </q-item-section>
              </q-item>

            </q-list>


          </q-btn-dropdown>
        </div>
        <div class="input-emptyclicks2">
          <q-btn-dropdown class="keywordandproduct" :label="selectedmultipleitems"
            style="background-color:rgb(255,255,255)!important ;" @focus="handleDropdownFocus" @blur="handleDropdownBlur"
            flip prevent-overlap @show="positionDropdown">
            <q-input v-model="selectedmultipleitemsDisplay" filled dense debounce="300" v-slot:prepend class="q-pa-sm"
              placeholder="Adgroup" style="min-width: 200px" />
            <q-list class="campaign-dropdown-list"
              style="background-color: rgb(255,255,255); max-height: 200px; overflow-y: auto;">
              <q-item v-for="(lists, campaign1) in recent_campaign_json[selectedCampaign1]?.associated_ad_gps || {}"
                :key="campaign1" clickable v-close-popup @click="toggleSelection(campaign1)">
                <q-item-label>
                  <q-checkbox v-model="multiSelectedAdGpItems" :val="campaign1" />
                  {{ campaign1 }}
                </q-item-label>
              </q-item>
              

            </q-list>


          </q-btn-dropdown>
        </div>
      </div>
    </div>
    <div class="table-container">
      <table>
        <thead style="background-color: rgb(16,38,137);">
          <tr style="background-color: rgb(16,38,137);">
            <th style=" border:none;"><input id="select-all-checkbox" class="custom-checkbox" type="checkbox"
                v-model="selectAll" @change="selectAllCheckboxes" /></th>
            <th><div class="column-header">Search Term<q-icon :name="sortColumns['searchTerm'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['searchTerm']" @click="sortTable('searchTerm')" /></div></th>
            <th><div class="column-header">Campaign<q-icon :name="sortColumns['campaignName'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['campaignName']" @click="sortTable('campaignName')" /></div></th>
            <th><div class="column-header">Type<q-icon :name="sortColumns['matchType'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['matchType']" @click="sortTable('matchType')" /></div></th>
            <th><div class="column-header">Impression<q-icon :name="sortColumns['impressions'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['impressions']" @click="sortTable('impressions')" /></div></th>
            <th><div class="column-header">Clicks<q-icon :name="sortColumns['clicks'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['clicks']" @click="sortTable('clicks')" /></div></th>
            <th><div class="column-header">CTR<q-icon :name="sortColumns['ctr'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['ctr']" @click="sortTable('ctr')" /></div></th>
            <th><div class="column-header">Cost<q-icon :name="sortColumns['cost'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['cost']" @click="sortTable('cost')" /></div></th>
            <th><div class="column-header">CPC<q-icon :name="sortColumns['cpc'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['cpc']" @click="sortTable('cpc')" /></div></th>
            <th><div class="column-header">Sales<q-icon :name="sortColumns['sales'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['sales']" @click="sortTable('sales')" /></div></th>
            <TH><div class="column-header">Orders<q-icon :name="sortColumns['orders'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['orders']" @click="sortTable('orders')" /></div></TH>
            <th><div class="column-header">CVR<q-icon :name="sortColumns['cvr'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['cvr']" @click="sortTable('cvr')" /></div></th>
            <th><div class="column-header">ROAS<q-icon :name="sortColumns['roas'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['roas']" @click="sortTable('roas')" /></div></th>
            <th><div class="column-header">ACOS<q-icon :name="sortColumns['acos'] ? 'arrow_downward' : 'arrow_upward'" size="20px"
                :color="sortColumns['acos']" @click="sortTable('acos')" /></div></th>
            <th><div class="column-header">Keyword Status<q-icon :name="sortColumns['adkeywordStatus'] ? 'arrow_downward' : 'arrow_upward'"
                size="20px" :color="sortColumns['adkeywordStatus']" @click="sortTable('adkeywordStatus')" /></div></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in tabledata">
            <tr style="
                        text-align: center;
                        /* font-weight: bold; */
                        /* font-family: arial; */
                      " @click="displaytable(index)" class="table-content">
              <!-- <td>{{ item.searchTerm }}</td> -->
              <!-- <td><input type="checkbox"></td> -->
              <td><input :id="'checkbox-' + index" type="checkbox" :checked="item.selected"
                  @change="handleCheckboxChange(index)" /><label :for="'checkbox-' + index"></label></td>
              <td class="td-col1">{{getEmailbasedSearchterm(item,index)}}</td>
              <td class="td-col1">{{ getEmailBasedCampaignName(item,index) }}</td>
              <td>{{ item.matchType }}</td>
              <td>{{ item.impressions }}</td>
              <td>{{ item.clicks }}</td>
              <td>{{ item.ctr }}</td>
              <td>{{ item.cost }}</td>
              <td>{{ item.cpc }}</td>
              <td>{{ item.sales }}</td>
              <td>{{ item.orders }}</td>
              <td>{{ item.cvr }}</td>
              <td>{{ item.roas }}</td>
              <td>{{ item.acos }}</td>
              <td>{{ item.adKeywordStatus }}</td>
            </tr>


          </template>
        </tbody>

      </table>
    </div>
    <div style="
          margin-top: 5px;
          padding-inline: 67px;
          display: flex;
          justify-content: end;
          gap: 14px;
        ">
      <!-- <button class="button-grup">clear</button> -->
      <button class="button-grup-red" style="background-color: rgb(16,38,137); margin-top: 40px; margin-bottom: 50px;"
        @click="acceptcall" :disabled="isblockingaccept">Accept</button>
    </div>

  </div>
</template>
  
    
<style scoped>
template {
  margin-top: 10px;

}
p,
th,
td,
tr {
  /* font-family: 'Amazon Ember', 'Helvetica Neue','Helvetica','Arial',sans-serif; */
  font-family: "Montserrat" sans-serif;
}

h4 {
  font: normal normal bold Raleway;
  font-weight: 510;
}

.keyword>.title {
  margin-left: 20px;
}

#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
  height: 50%;
}
.column-header {
    display: flex;
    align-items: center;
    justify-content: center;
  }

.box {
  height: 72px;
  margin-top: 0px;
  background: rgb(238, 239, 242);

}

.box select {
  width: 300px;
  height: 40px;
  border: 1px solid #f1f2f6;
  border-radius: 10px;

}

.box>.portfolio {
  width: 300px;
  height: 40px;
  border: 1px solid #f1f2f6;
  border-radius: 10px;

}

.box .keywordandproduct {
  width: 300px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);


}

.keywordandproduct {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.keywordandproduct q-item-label {
  white-space: normal;
}

.keywordandproduct q-item-section {
  width: 100%;

}

.campaign-dropdown-list {
  max-height: 900px;
  /* Adjust the height as needed */
  overflow-y: auto;
  overflow-x: auto;
}

.campaign-dropdown-content {
  max-height: 700px;
  /* Set the desired max-height to limit the dropdown size */
  overflow-y: auto;
  /* Add a scrollbar when the content exceeds the max height */
}

.q-btn__label {
  display: none;
}

.box .dateDropDown {
  width: 300px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);

}

.custom-overflow {
  white-space: nowrap; /* Prevent text from wrapping */
    text-overflow: ellipsis; /* Display ellipsis for overflowed text */
    overflow: hidden;
}


.boxdouble {
  display: flex;
  place-self: flex-end;
  gap: 40.5px;
  width: 380px;
  margin-left: 0px;

}

.boxdouble>.box-boxdouble1 {
  display: flex;
  justify-content: space-between;
}

.boxdouble select {
  width: 130px;
  display: flex;
  justify-content: space-between;
}

.boxdouble>.box-boxdouble1>.input1 {
  margin-left: 25px;
  margin-right: 25px;


}

.boxdouble>.box-boxdouble1>.input2 {
  margin-left: 4.5px;
  margin-right: 0px;
}

.boxdouble>.box-boxdouble1>.input-roas {
  margin-left: 40px;
  margin-right: 40px;
}

.boxdouble>.box-boxdouble1>select {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
}

.boxdouble>.box-boxdouble1>.input-campaigntype {
  margin-left: 35px;
  margin-right: 20px;
}

.boxdouble>.box-boxdouble1>.input-emptycampaigntype {

  margin-top: 20px;
  margin-left: 10px;
}

.boxdouble>.box-boxdouble1>.input-emptycampaigntype>.input-field-doublebox {
  width: 130px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);

}

.boxdouble>.box-boxdouble1>.input-emptycampaigntypes {

  margin-top: 20px;
  margin-left: 17px;

}

.boxdouble>.box-boxdouble1>.input-emptycampaigntypes>.input-field-doublebox {
  width: 130px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);

}

.boxdouble>.box-boxdouble1>.input-cost {
  margin-right: 28px;
  margin-left: 30px;
}

.boxdouble>.box-boxdouble1>.input-impression {
  margin-left: 35px;
  margin-right: 28px;
}

.boxdouble>.box-boxdouble1>.input-emptyclicks {
  margin-top: 20px;
  margin-left: 25px;
}

.boxdouble>.box-boxdouble1>.input-emptyclicks>.input-field-doublebox {
  width: 130px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
}

.boxdouble>.box-boxdouble1>.input-emptyclicks1 {
  margin-top: 20px;

}

.boxdouble>.box-boxdouble1>.input-emptyclicks1>.input-field-doublebox {
  width: 130px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);

}

.boxdouble>.box-boxdouble1>.input-emptyclicks2 {
  margin-top: 20px;
  margin-left: 20px;

}

.boxdouble>.box-boxdouble1>.input-clicks {
  margin-left: 35px;
  margin-right: 10px;
}

.boxdouble>.box-boxdouble1>.Roas {
  margin-left: 30px;
  margin-right: 40px;
}

.boxdouble>.box-boxdouble1>.input-emptyclicks-acos {
  margin-top: 20px;
}

.boxdouble>.box-boxdouble1>.input-emptyclicks-acos>.input-field-doublebox {
  width: 130px;
  height: 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
}

.boxdouble>.box-boxdouble1>.input-ctr {
  margin-left: 35px;
  margin-right: 10px;
}

.boxdouble .date {
  width: 130px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #f1f2f6;
  height: 40px;
  border-radius: 10px;
  background-color: rgb(255, 255, 255);

}


.button-grup {
  width: 82px;
  background: rgb(255, 0, 0) 0% 0% no-repeat padding-box;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 16px;
  color: white;
  border: none;
}

.button-grup-red {
  width: 82px;
  background: #007bff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 16px;
  color: white;
  border: none;
}

select {
  color: black;
}

select option {
  color: black;
}


.table-container {
  margin-top: 30px;
  font-family: 'Poppins', sans-serif;

}

.table-container th {
  position: sticky;
  top: 0px;
  text-align: center;
  background-color: rgb(18, 48, 137);
  color: white;

}

.table-container {
  max-width:max-content;
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: scroll;
  border: 2px solid white;
  background-color: white;
  
}

.table-container>table>tbody>tr>.td-col1 {
  text-align: left;
}
</style>
<script>
import { ref } from 'vue'


export default {


  setup() {
    //date range in calender.Other dates will be blocked
    const dateRange = ref({ from: '', to: '' })
    return {
      dateRange,
    }
  },
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      campaign_list: "select Campaign",
      adgroup_list: "select Adgroup",
      operators: ['>', '<', '='],
      multiSelectedItems: [],
      selectedCampaign: 'Select',
      selectedAdgroup: 'Select',
      selectedCampaign1: 'Select Campaign',
      selectedmultipleitems: [],
      targetselector: 'Select',
      campaigntypeselector: 'Sponsored Product',
      statetype: 'Select',
      negativematchtype: 'Select Matchtype',
      selectedoperator: 'Select',
      selectedoperator1: 'Select',
      selectedoperator2: 'Select',
      selectedoperator3: 'Select',
      selectedoperator4: 'Select',
      selectedoperator5: 'Select',
      selectedoperator6: 'Select',
      targetting: ['Select', 'Broad', 'Exact', 'Phrase', 'Targeting_Expression', 'Targeting_Expression_Predefined'],
      campaigntype: ['Sponsored Product', 'Sponsored Brand'],
      state: ['Select', 'Enabled', 'Paused'],
      negativematch: ['Negative Exact', 'Negative Phrase'],
      portfoliovalue: null,
      keywordsearchvalue: null,
      productasinvalue: null,
      portfolio_button: "None",
      portfolio: "",
      targetselector: 'Select',
      Targetingvalue: null,
      campaignvalue: null,
      campaigntypevalue: null,
      statetypevalue: null,
      selectedmultipleitems: 'Select Adgroup',
      advalue: null,
      negativecmpaign: null,
      negativecampaignid: null,
      selectedCampaignID: null,
      negative_filter: null,
      adgroupvalue: "",
      daterangevalue: '',
      value: null,
      value1: null,
      ctrvalue: null,
      cvrvalue: null,
      clicksvalue: null,
      roasvalue: null,
      ordervalue: null,
      searchQuery: "",
      searchQuery1: "",
      searchQuery2: "",
      searchQuery3: "",
      selectedValue: "",
      dateValuecalendar: null,
      dateRange: null,
      campaign_data: [],
      adgroup_data: [],
      recent_data: [],
      sales_button: null,
      cost_button: null,
      ctr_button: null,
      cvr_button: null,
      clicks_button: null,
      roas_button: null,
      orders_button: null,
      Targeting_button: null,
      selectedColumnValue: "",
      selectedAdValue: "",
      tablular_data: [],
      filteredtabular_data: [],
      multiSelectedAdGpItems: [],
      selectedItems: [],
      compaignnegativefilter: [],
      campaignNames: [],
      selectAll: false,
      mindate: new Date(),
      selectedCampaignNameUI: '',
      negative_adgroup_name: [],
      checkboxClicked: false,
      temp_date: "",

      sortColumns: {
        searchTerm: false,
        campaignName: false,
        matchType: false,
        impressions: false,
        clicks: false,
        ctr: false,
        cpc: false,
        roas: false,
        acos: false,
        sales: false,
        orders: false,
        cvr: false,
        cost: false,
        adKeywordStatus: false,
        // Add other columns here
      },
      // negativematchtype:false,
      // keywordDataArray:false,
      // negative_adgroup_name:false,
      // negative_campaign_name:false,



    }
  },
  watch: {
    searchQuery(newQuery, oldQuery) {
      // Check if the length of the search query is less than the previous value
      if (newQuery.length < oldQuery.length) {
        this.selectAll = false; // Uncheck the "Select All" checkbox
      }
    },
    associatedValues() {
      return this.recent_campaign_json[this.selectedCampaign1]?.associated_ad_gps
        ? Object.values(this.recent_campaign_json[this.selectedCampaign1].associated_ad_gps)
        : [];
    }
  },
  async created() {
    this.pageLoadTime = new Date();
    var currentUrl = window.location.href;
    var path = window.location.pathname;
    this.$q.loading.show({
      message: "Authenticating please wait...",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: :00", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/amazonadoptimization/keywordSearchTerm");
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: :00", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: :00", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/amazonadoptimization/adschedule");
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
  },
  mounted() {
    this.$mixpanel.track('keyword and searchterm page : Page Viewed', {
    PageName: 'Keyword Search Term Page',
    UserID: 'support@uniqin.ai', 
  });
  this.pageLoadTime = new Date();
  

    
    this.$q.loading.show({
      message: 'Loading...'
    });
    this.date()
    this.firstTableCall()
    const campaignNamesList = [];
    for (let i = 0; i < this.recent_campaign_json.length; i++) {
      const campaignName = this.recent_campaign_json[i].campaignName;
      campaignNamesList.push(campaignName);
    }
    console.log("campaignlistts", campaignNamesList);
  },
  beforeDestroy() {
  // Calculate the time spent on the page
  const currentTime = new Date();
  const timeSpentInSeconds = Math.floor((currentTime - this.pageLoadTime) / 1000);

  // Replace 'unique_user_identifier' with the actual unique user identifier
  const userID = 'your_actual_user_id';

  // Track the time spent on the page with user information
  this.$mixpanel.track('keyword and searchterm page :Time Spended', {
    PageName: 'Keyword Search Term Page',
    TimeSpentInSeconds: timeSpentInSeconds,
    UserID: userID, // Use a real unique identifier here
  });
},
  

  computed: {
    getCampaignItems() {
      const email = this.$store.state.credentials['attributes']['email'];
      // Check if the email is 'support@uniqin.ai'
      if (email === 'support@uniqin.ai') {
        // Return 'sample' instead of your data
        return ['sample'];
      } else {
        // Return your data based on your logic
        return this.filteredCampaigns; // Replace with your data source
      }

    },
    getAdgroupItems() {
      const email = this.$store.state.credentials['attributes']['email'];
      // Check if the email is 'support@uniqin.ai'
      if (email === 'support@uniqin.ai') {
        // Return 'sample' instead of your data
        return ['sample'];
      } else {
        // Return your data based on your logic
        return this.filteredAdgroups; // Replace with your data source
      }

    },
    getemailbasednegativecampaign(){
      const email = this.$store.state.credentials['attributes']['email'];
      // Check if the email is 'support@uniqin.ai'
      if (email === 'support@uniqin.ai') {
        // Return 'sample' instead of your data
        return ['sample'];
      } else {
        // Return your data based on your logic
        return Object.keys(this.recent_campaign_json); // Replace with your data source
      }

    },
    
    isblockingaccept(){
      const email = this.$store.state.credentials['attributes']['email']
      return email === 'support@uniqin.ai';
    },

    filteredCampaigns() {
      const searchFilter = this.searchQuery.toLowerCase();
      console.log('Search Query:', searchFilter);
      const frontenddata = ["Select", ...this.campaign_data.filter(campaign =>
        campaign.toLowerCase().includes(searchFilter)
      )];

      return frontenddata;



    },
    filteredAdgroups() {
      const searchFilters = this.searchQuery1.toLowerCase();
      console.log('Search Query:', searchFilters);
      const frontenddata1 = ["Select", ...this.adgroup_data.filter(adgroups =>
        adgroups.toLowerCase().includes(searchFilters)
      )];

      return frontenddata1;

    },
    dropdownItems() {
      // Add 'Select' as the default option and concatenate it with the filtered campaigns
      return [{ label: "Select", value: null }, ...this.filteredCampaigns];
    },
    filteredCampaigns1() {
      const searchFilter1 = this.searchQuery2.toLowerCase();
      console.log('Search Query:', searchFilter1);

      const frontenddata2 = ["Select", ...this.recent_data.filter(campaign1 =>
        campaign1.toLowerCase().includes(searchFilter1)
      )];
      return frontenddata2;
    },
    filteredCampaigns2() {
      const searchFilters = this.searchQuery3.toLowerCase();
      console.log('Search Query:', searchFilters);

      const frontenddata3 = ["Select", ...this.multiple_data.filter(lists =>
        lists.toLowerCase().includes(searchFilters)
      )];

      return frontenddata3;
    },
    filteredtabledata() {
      return this.applycall();
    },
    dateRangeWithComma() {
      if (this.dateRange[0] && this.dateRange[1]) {
        // Format the selected start and end dates with a comma
        return this.dateRange[0] + ', ' + this.dateRange[1];
      }
      return '';
    },

    campaignDropdownClass() {
      return this.isCampaignProblem ? "dropdown-problem" : "";
    }

  },
  selectedmultipleitemsDisplay() {
    // Map the selected items to a comma-separated string
    return this.multiSelectedAdGpItems.join(', ');
  },
  dynamicPlaceholder() {
    const currentDate = new Date();
    const month = currentDate.toLocaleString('default', { month: 'long' });
    return `Select a date in ${month}`;
  },
  methods: {
    getEmailBasedCampaignName(item,index) {
        const email = this.$store.state.credentials['attributes']['email'];
        if (email === 'support@uniqin.ai') {
            return `Campaign ${index + 1}`;
        }
        
        return item.campaignName;
    },
    getEmailbasedSearchterm(item,index){
      const email = this.$store.state.credentials['attributes']['email'];
        if (email === 'support@uniqin.ai') {
          return `SearchTerm ${index + 1}`;
        }
        
        return item.searchTerm;

    },
    date() {
      var date = new Date();
      var dd = String(date.getDate()).padStart(2, '0');
      var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date.getFullYear();
      this.today_date = yyyy + '/' + mm + '/' + dd;
      this.temp_date = this.today_date;
      this.optionsFn(date)
    },
    optionsFn(date) {
      return date <= this.temp_date;

    },

    firstTableCall() {
      // this.selectedItems = [];
      this.$q.loading.show({
        message: 'Loading...'
      });




      var ProductURL = this.api_url + "/amazon-ad/get_searchterm_all_data/" + this.$org_id.label;
      this.$http
        .post(ProductURL)
        .then((response) => {
          this.tabledata = response.data.searchtermdata;
          console.log("tabulardata", this.tabledata);
          this.campaign_data = response.data.campaignlist;
          this.adgroup_data = response.data.adgroups;
          this.multiple_data = response.data.recent_campaign_list;
          console.log("console", response.data)
          this.recent_campaign_json = response.data.recent_campaign_list;

          let searchterm_data = response.data.searchtermdata.map((item) =>
            item.searchTerm
          );
          console.log("searchtermdata", searchterm_data)

  
            this.$forceUpdate();
            this.$q.loading.hide();
          }).catch(()=>{
            this.$q.loading.hide();
          });
        },
       
        setCampaigndata(list) {

        this.apicall(list);
        // this.generateGraph();
      },
      handlecheck(index){
        this.tabledata[index].selected= !this.tabledata[index]
        if (this.tabledata[index].selected){
          this.selectedItems.push(this.tabledata[index])
        }
        else{
          this.selectedItems=this.selectedItems.filter(item=> item!== this.tabledata[index])
        }

      },
      positionDropdown() {
        // Get references to the dropdown and anchor elements
        const dropdownEl = this.$refs.dropdown.$el
        const anchorEl = this.$refs.dropdownAnchor
  
        // Calculate the position of the anchor element relative to the viewport
        const anchorRect = anchorEl.getBoundingClientRect()
  
        // Set the position of the dropdown
        dropdownEl.style.position = 'fixed'
        dropdownEl.style.left = anchorRect.left + 'px'
        dropdownEl.style.top = anchorRect.bottom + 'px'
      },
      onTargetting(targetitem){
        this.targetselector=targetitem;
        this.searchQuery="";
      },
      oncampaigntype(campaignitems){
        this.campaigntypeselector=campaignitems;
        this.searchQuery="";
      },
      onstate(stateitems){
        this.statetype = stateitems;
        this.searchQuery="";
      },
      onCampaignSelect(campaign) {
        this.selectedCampaign = campaign;
      this.searchQuery = ""; 
      },
      onOperator(operator){
        this.selectedoperator = operator;
        this.searchQuery = "";
      },
      onOperator1(operator1){
        this.selectedoperator1 = operator1;
        this.searchQuery = "";
      },
      onOperator2(operator2){
        this.selectedoperator2 = operator2;
        this.searchQuery = "";
      },
      onOperator3(operator3){
        this.selectedoperator3 = operator3;
        this.searchQuery = "";
      },
      onOperator4(operator4){
        this.selectedoperator4 = operator4;
        this.searchQuery = "";
      },
      onOperator5(operator5){
        this.selectedoperator5 = operator5;
        this.searchQuery = "";
      },
      onOperator6(operator6){
        this.selectedoperator6 = operator6;
        this.searchQuery = "";
      },
      onnegativetype(Negative){
        this.negativematchtype=Negative;
        this.searchQuery="";
      },
      onAdgroupSelect(adgroups) {
        // Update the selected campaign when the user clicks on a campaign in the dropdown list
        console.log("Selected Adgroup:", adgroups);
        this.selectedAdgroup = adgroups;
        
        // Clear the search query and hide the dropdown list after selection
        this.searchQuery1 = "";
      },
      onCampaignSelect1(campaign1) {
        // Update the selected campaign when the user clicks on a campaign in the dropdown list
        this.selectedCampaign1 = campaign1;
        console.log("selected key:", campaign1);
        // Clear the search query and hide the dropdown list after selection
        this.selectedValue = "";
      },
      onCampaignselect2(lists){
        // this.selectedValue = lists;
        this.selectedmultipleitems=lists;
        // this.searchQuery3="";
        console.log("Selected value:", lists)
      },
      handleDropdownFocus() {
        this.isDropdownOpen = true; // Show the dropdown list when it receives focus
      },
      toggleSelection(item) {
      if (this.multiSelectedAdGpItems.includes(item)) {
        const index = this.multiSelectedAdGpItems.indexOf(item);
        this.multiSelectedAdGpItems.splice(index, 1);
      } else {
        this.multiSelectedAdGpItems.push(item);
      }
    },
    sortTable(column) {
      const descending = this.sortColumns[column];
      this.sortColumns[column] = !descending;
      // Sort the tabledata based on the selected column and direction
      this.tabledata.sort((a, b) => {
        if (a[column] < b[column]) {
          return descending ? -1 : 1; // Sort ascending or descending based on direction
        }
        if (a[column] > b[column]) {
          return descending ? 1 : -1; // Sort ascending or descending based on direction
        }
        return 0;
      });
      // ... other methods ...
    },
    handleDropdownBlur() {
      this.isDropdownOpen = false; // Hide the dropdown list when it loses focus
    },

    setadgroupdata(ad_list) {
      this.apicall_ad(ad_list);

    },
    apicall(list) {
      this.isCampaignProblem = list.trim() === "";
      this.campaign_list = list;
    },
    apicall_ad(ad_list) {
      this.adgroup_list = ad_list;
    },
    selectAllCheckboxes() {
      // Update the selected state of all checkboxes based on the "Select All" checkbox
      if (this.selectAll === true) {
        this.tabledata.forEach((item) => {
          item.selected = true;
          if (!this.selectedItems.includes(item)) {
            this.selectedItems.push(item);
          }
        });

      } else {
        this.tabledata.forEach(item => {
          item.selected = false;
        });
        this.selectedItems = [];
      }
    },

    handleCheckboxChange(index) {
      // Update the state of the clicked checkbox
      this.tabledata[index].selected = !this.tabledata[index].selected;
      // const associatedAdGroupValues = Object.values(this.recent_campaign_json[this.tabledata[index].selectedCampaignName]?.associated_ad_gps || {});


      // Update the array of selected items
      if (this.tabledata[index].selected) {
        // Add the selected item to the array
        this.selectedItems.push(this.tabledata[index]);

        this.selectedColumnValue = this.tabledata[index].searchTerm;


      } else {
        // this.selectedSearchTerms.filter(term => term !== this.tabledata[index].searchTerm);
        // Remove the unselected item from the selectedItems array
        this.selectedItems = this.selectedItems.filter((item) => item !== this.tabledata[index].searchTerm);

      }
      // Update the state of the "Select All" checkbox based on selected checkboxes
      if (this.selectedItems.length === this.tabledata.filter((item) => item.exist_rules === "").length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },

    closeStartDateCalendar() {
      this.$refs.qStartDateProxy.hide();
      this.dateValuecalendar = this.dateRange.from + ' - ' + this.dateRange.to
    },
    getCurrentMonthFormatted() {
  const currentDate = new Date();
  
  // Calculate the last month and current month
  const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
  const currentMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

  // Get the year and month of the last month
  const lastMonthYear = lastMonth.getFullYear();
  const lastMonthMonth = String(lastMonth.getMonth() + 1).padStart(2, '0');

  // Get the year and month of the current month
  const currentMonthYear = currentMonthStart.getFullYear();
  const currentMonthMonth = String(currentMonthStart.getMonth() + 1).padStart(2, '0');

  // Create the formatted date range string
  const startDate = `${lastMonthYear}/${lastMonthMonth}/${currentDate.getDate()}`;
  const endDate = `${currentMonthYear}/${currentMonthMonth}/${currentDate.getDate()}`;
  
  return `${startDate} - ${endDate}`;
},
    applycall() {
      this.$mixpanel.track('Keyword and Search term : Applied',{
        info:'user selected Apply function'
      });
      const errorMessages = [];
      if (parseFloat(this.value)) {
        if (!this.operators.includes(this.selectedoperator)) {
          errorMessages.push("Please select a valid operator for sales.");
        }
      }
      if (parseFloat(this.value1)) {
        if (!this.operators.includes(this.selectedoperator1)) {
          errorMessages.push("Please select a valid operator for cost");
        }
      }
      if (parseFloat(this.ctrvalue)) {
        if (!this.operators.includes(this.selectedoperator2)) {
          errorMessages.push("Please select a valid operator for ctr");
        }
      }
      if (parseFloat(this.cvrvalue)) {
        if (!this.operators.includes(this.selectedoperator3)) {
          errorMessages.push("Please select a valid operator for cvr");
        }
      }
      if (parseInt(this.clicksvalue)) {
        if (!this.operators.includes(this.selectedoperator4)) {
          errorMessages.push("Please select a valid operator for clicks");
        }
      }
      if (parseFloat(this.roasvalue)) {
        if (!this.operators.includes(this.selectedoperator5)) {
          errorMessages.push("Please select a valid operator for Roas");
        }
      }
      if (parseInt(this.ordervalue)) {
        if (!this.operators.includes(this.selectedoperator6)) {
          errorMessages.push("Please select a valid operator for orders");
        }
      }

      // Check if any errors occurred
      if (errorMessages.length === 0) {
        // Perform the apply call
        // ...
      } else {
        // Display error messages
        this.$q.notify({
          type: 'negative',
          message: errorMessages.join(' ')
        });
      }


      if (parseFloat(this.value) < 0) {
        errorMessages.push("Sales must be greater than or equal to 0.");
      }
      if (parseFloat(this.value1) < 0) {
        errorMessages.push("Cost must be greater than or equal to 0.");
      }
      if (parseFloat(this.ctrvalue) < 0 || parseFloat(this.ctrvalue) > 1) {
        errorMessages.push("CTR must be between 0 and 1.");
      }
      if (parseFloat(this.cvrvalue) < 0 || parseFloat(this.cvrvalue) > 100) {
        errorMessages.push("CVR must be between 0 and 100.");
      }
      if (this.clicksvalue !== undefined && this.clicksvalue !== null && this.clicksvalue !== '') {
  const inputValue = this.clicksvalue.trim(); // Remove leading/trailing whitespace
  
  if (/^\d+$/.test(inputValue) && parseInt(inputValue) >= 0) {
    // Input is a non-negative integer
  } else {
    errorMessages.push("Clicks must be a non-negative integer.");
  }
}

      if (parseFloat(this.roasvalue) < 0) {
        errorMessages.push("ROAS must be greater than or equal to 0.");
      }
      if (this.ordervalue !== undefined && this.ordervalue !== null && this.ordervalue !== '') {
  const inputValue = this.ordervalue.trim(); // Remove leading/trailing whitespace
  
  if (/^\d+$/.test(inputValue) && parseInt(inputValue) >= 0) {
    // Input is a non-negative integer
  } else {
    errorMessages.push("Orders must be a non-negative integer.");
  }
}
      const isPortfolioValueNull = this.portfoliovalue === null || this.portfoliovalue === undefined;
      const isTargetingValueNull = this.Targetingvalue === null;
      const isCampaignvalueNull = this.campaignvalue === null;
      const isAdgroupvalueNull = this.advalue === null;
      const isDateRangeValid = this.daterangevalue === null;
      const iskeywordsearch = this.keywordsearchvalue === null || this.keywordsearchvalue === undefined;
      const isproductasin = this.productasinvalue === null || this.productasinvalue === undefined;
      const iscampaigntype = this.campaigntypevalue === null;
      const isstatetype = this.statetypevalue === null;
      // if (isPortfolioValueNull || isTargetingValueNull || isCampaignvalueNull || isAdgroupvalueNull || iskeywordsearch || isproductasin || iscampaigntype || isstatetype ||isDateRangeValid) {
      //   errorMessages.push("Please make sure all required fields are entered.");
      // }
      if (errorMessages.length === 0) {
        // Define the filtering conditions for each field
        const filterConditions = {
          sales: value => parseFloat(value) >= parseFloat(this.value),
          cost: value => parseFloat(value) >= parseFloat(this.value1),
          ctr: value => parseFloat(value) >= parseFloat(this.ctrvalue) && parseFloat(value) <= 100,
          cvr: value => parseFloat(value) >= parseFloat(this.cvrvalue) && parseFloat(value) <= 100,
          clicks: value => Number.isInteger(parseInt(value)) && parseInt(value) >= parseInt(this.clicksvalue),
          roas: value => parseFloat(value) >= parseFloat(this.roasvalue),
          orders: value => Number.isInteger(parseInt(value)) && parseInt(value) >= parseInt(this.ordervalue)
        };
        this.filteredTableData = this.tabledata.filter((item) => {
          return Object.entries(filterConditions).every(([field, condition]) => {
            const fieldValue = item[field];
            return condition(fieldValue);
          });
        });
        // If there are no items that match the filtering conditions, show a message

        this.$q.loading.show({
          message: ''
        });
        var productsURL = this.api_url + "/amazon-ad/filter_searchterm_all_data/" + this.$org_id.label;
        this.$http
          .post(productsURL, this.backenddata())
          .then((response) => {
            this.tabledata = response.data;
            console.log(this.tabledata)
            this.$forceUpdate();
            this.$q.loading.hide();

          }).catch(() => {
            this.$q.loading.hide();
          });

      }



      else {
        this.filteredtabular_data = this.tablular_data;
        this.$q.notify({
          type: 'negative',
          message: errorMessages.join(' ')
        });
      }
    },

    backenddata() {
      // const portfolioValue = this.portfoliovalue !== undefined ? this.portfoliovalue : '';
      // const portfolioValue = this.portfoliovalue !== null && this.portfoliovalue !== undefined ? this.portfoliovalue : 'None';

      return [
        {
          portfolio: this.portfoliovalue !== null ? "=" + "_" + (this.portfoliovalue === "" ? "" : this.portfoliovalue) : "",
          targeting: this.targetselector ? "=" + "_" + this.targetselector : "",
          campaignName: this.selectedCampaign ? + "_" + this.selectedCampaign : "",
          adGroupName: this.selectedAdgroup ? + "_" + this.selectedAdgroup : "",
          keyword: this.keywordsearchvalue !== null ? + "_" + (this.keywordsearchvalue === "" ? "" : this.keywordsearchvalue) : "",
          campaignName: this.selectedCampaign ? "=" + "_" + this.selectedCampaign : "",
          adGroupName: this.selectedAdgroup ? "=" + "_" + this.selectedAdgroup : "",
          keyword: this.keywordsearchvalue !== null ? "=" + "_" + (this.keywordsearchvalue === "" ? "" : this.keywordsearchvalue) : "",
          ProductASIN: this.productasinvalue !== null ? "=" + "_" + (this.productasinvalue === "" ? "" : this.productasinvalue) : "",
          Campaigntype: this.campaigntypeselector ? + "_" + this.campaigntypeselector : "",
          State: this.statetype ? + "_" + this.statetype : "",
          Campaigntype: this.campaigntypeselector ? "=" + "_" + this.campaigntypeselector : "",
          State: this.statetype ? "=" + "_" + this.statetype : "",
          daterange: this.dateValuecalendar ? this.dateValuecalendar : this.getCurrentMonthFormatted(),
          sales: this.value ? this.selectedoperator + "_" + this.value : "",
          cost: this.value1 ? this.selectedoperator1 + "_" + this.value1 : "",
          ctr: this.ctrvalue ? this.selectedoperator2 + "_" + this.ctrvalue : "",
          cvr: this.cvrvalue ? this.selectedoperator3 + "_" + this.cvrvalue : "",
          clicks: this.clicksvalue ? this.selectedoperator4 + "_" + this.clicksvalue : "",
          roas: this.roasvalue ? this.selectedoperator5 + "_" + this.roasvalue : "",
          orders: this.ordervalue ? this.selectedoperator6 + "_" + this.ordervalue : "",


        }

      ];

    },
    clearForm(clearLastFourValues = true) {
      this.$mixpanel.track('keyword and Searchterm page : cleared',{
        info:'user clear the filter'
      })

      this.value = "";
      this.value1 = "";
      this.ctrvalue = "";
      this.cvrvalue = "";
      this.clicksvalue = "";
      this.roasvalue = "";
      this.ordervalue = "";
      this.selectedoperator = "Select";
      this.selectedoperator1 = "Select";
      this.selectedoperator2 = "Select";
      this.selectedoperator3 = "Select";
      this.selectedoperator4 = "Select";
      this.selectedoperator5 = "Select";
      this.selectedoperator6 = "Select";
      this.dateValuecalendar = this.getCurrentMonthFormatted();
      this.portfoliovalue = null;
      this.keywordsearchvalue = null,
      this.productasinvalue = null,
      this.campaigntypeselector = 'Sponsored Product';
      this.statetype = 'Select';
      this.targetselector = 'Select';
      this.selectedCampaign = 'Select';
      this.selectedAdgroup = 'Select';
      
      // this.handleCheckboxChange();
      // this.applycall();


    },
    bottomfilterclearing(){
      this.negativematchtype = 'Select Matchtype';
        this.selectedCampaign1 = 'Select Campaign';
        this.selectedmultipleitems = 'Select Adgroup';
        this.selectedItems = [];
        this.tabledata.forEach(item => {
          item.selected = false;
          this.selectAll = false;
          
        });
        
        // Clear the selectedTableItems array
        
        this.selectedTableItems = [];
        this.multiSelectedAdGpItems = [];

    },
    clearButtonClicked() {
      // Called when the "Clear" button is clicked
      // Clear all form fields except the last 4 values
      this.clearForm(false);
    },
    acceptcall() {
      this.$mixpanel.track('keyword and searchterm page : Accepted',{
        info:'user selected accept fumction'
      })
     

      // const negative_campaign = this.negativecampaignid===null;
      // const negative_matchtype = this.negative_match==="";
      const columnValue = this.selectedColumnValue;
      // console.log("coulmnvalue",columnValue)
      const isnegativecampaign = this.negativecmpaign === null;
      // const isNegativetype= this.statetype;
      const isNegativecampaign = this.negativematchtype;
      const selectedCampaignName = this.selectedCampaign1;
      this.negative_campaign_name = this.selectedCampaign1;
      // console.log("adgp", this.recent_campaign_json[selectedCampaign1]?.associated_ad_gps || {})

      console.log('wwww', selectedCampaignName)
      const campaignID = this.recent_campaign_json[selectedCampaignName]?.campaignID;
      console.log('2222', this.recent_campaign_json[selectedCampaignName]?.associated_ad_gps || {})
      this.StateValue = this.recent_campaign_json[selectedCampaignName]?.state;
      this.adTypevalue = this.recent_campaign_json[selectedCampaignName]?.adType;
      this.budgetvalue = this.recent_campaign_json[selectedCampaignName]?.budget;
      this.startdatevalue = this.recent_campaign_json[selectedCampaignName]?.startDate;
      this.enddatevalue = this.recent_campaign_json[selectedCampaignName]?.endDate;
      this.keywordstatusvalue = this.recent_campaign_json[selectedCampaignName]?.adKeywordStatus;
      const AdgroupID = this.selectedAdValue;
      console.log("adgroupid", AdgroupID)
      this.selectedCampaignName = selectedCampaignName
      console.log("cname", selectedCampaignName)
      this.selectedIDs = [];
      // Loop through the selected items and get the corresponding adGroup IDs
      for (const selectedAdGpItem of this.multiSelectedAdGpItems) {
        const selectedID = this.recent_campaign_json[selectedCampaignName]?.associated_ad_gps[selectedAdGpItem];
        if (selectedID) {
          this.selectedIDs.push(selectedID);
        }
      }
      // Handle the case when no adGroup is selected
      if ( this.selectedIDs.length === 0) {
        this.$q.notify({
          type: 'negative',
          message: "Please select Matchtype,Campaign and Adgroup",
        });

        return; // Stop execution if no keywords are selected

      }

      // Use the selected adGroup IDs
      console.log("Selected Ad Group IDs:", this.selectedIDs);

      if (campaignID || isNegativecampaign) {
        this.selectedCampaignNameUI = selectedCampaignName;
        this.selectedCampaign1 = campaignID;
        this.negativematchtype = isNegativecampaign;
        const adgpKeys = Object.keys(this.recent_campaign_json[selectedCampaignName]?.associated_ad_gps || {});

        if (adgpKeys.length > 0) {
          this.negative_adgroup_name = adgpKeys;

          // Print the ad group keys to the console
          console.log("Ad Group Keys:", adgpKeys);
        } else {
          console.error('No Ad Group Names (Keys) found in associated_ad_gps.');
        }
        const associatedAdGroupValues = Object.values(this.recent_campaign_json[selectedCampaignName]?.associated_ad_gps || {});
        if (associatedAdGroupValues.length > 0) {
          this.negative_adgroup_id = associatedAdGroupValues;

          // Print the ad group values to the console
          console.log("Ad Group Values:", associatedAdGroupValues);
        } else {
          console.error('No Ad Group Values found in associated_ad_gps.');
        }
        // this.selectedCampaign1 = StateValue;
        // this.statetype= isNegativetype;
      } else {
        // Handle the case when the campaignID is not found for the selected campaign name
        console.error('Campaign ID not found for selected campaign:', selectedCampaignName);
      }

      if (campaignID && isNegativecampaign) {
        if (this.selectedItems.length === 0) {
          this.$q.notify({
            type: 'negative',
            message: "Please select at least one searchterm.",
          });
          this.bottomfilterclearing();
          return; // Stop execution if no keywords are selected

        }
      }




      this.$q.loading.show({
        message: ''
      });
      var productsURLs = this.api_url + "/amazon-ad/add_to_negative_searchterms/" + this.$org_id.label;
      this.$http
        .post(productsURLs, this.backend_negative_data())
        .then((response) => {
          this.tabledatas = response.data;
          console.log("negative", response.data)
          console.log("response", response)
          this.$q.loading.hide();
          if (response.data.code === 'SUCCESS') {
            this.$q.notify({
              type: 'positive',
              message: response.data.description
            });
          } else if (response.data.code === 'ERROR') {
            this.$q.notify({
              type: 'negative',
              message: response.data.description
            });
          }



        }).catch(() => {
          this.$q.loading.hide();



        });



      this.bottomfilterclearing();





    },
    backend_negative_data() {

      // const associatedAdGroupValues = this.recent_campaign_json[this.selectedCampaignName]?.associated_ad_gps[this.selectedmultipleitems];
      // this.negative_adgroup_name = Object.key(this.recent_campaign_json[selectedCampaign1]?.associated_ad_gps || {});

      const keywordDataArray = this.selectedItems.map(term => [
        term.searchTerm,
        term.adKeywordStatus
      ]);



      return [{
        campaignId: this.selectedCampaign1 ? + this.selectedCampaign1 : "",
        state: this.StateValue,
        matchType: this.negativematchtype,
        keywordText: keywordDataArray,
        adGroupId: this.selectedIDs,
        adType: this.adTypevalue,
        budget: this.budgetvalue,
        startDate: this.startdatevalue,
        endDate: this.enddatevalue,
        campaignName: this.negative_campaign_name,
        adgpName: this.multiSelectedAdGpItems,
        // negativecampaignID : this.selectedmultipleitems ? "=_" + this.selectedmultipleitems:"",
      }]
    },
    submit(allTrue) {
      this.$q.loading.show({
        message: 'Loading...'
      });
      if (this.negativematchtype == true && this.negative_campaign_name == true && this.keywordDataArray == true && allTrue === true) {
        var productsURLs = this.api_url + "/amazon-ad/add_to_negative_searchterms";
        this.$http.post(productsURLs, this.backend_negative_data())
          .then((response) => {
            if (response.data) {
              this.negativematchtype = false
              this.keywordDataArray = false
              this.negative_adgroup_name = false
              this.negative_campaign_name = false
              this.$q.notify({
                type: 'positive',
                message: "filters created Successfully",
              })
              this.$q.loading.hide();
              this.disableSubmit = false;

            }
            else {
              this.$q.notify({
                type: 'negative',
                message: "filters not created",
              })
              this.$q.loading.hide();
              this.disableSubmit = false;
            }
          }).catch(() => {
            this.$q.loading.hide();
          });
      }
      else {
        this.$q.notify({
          type: 'negative',
          message: "Please Fill all required columns",
        })
        this.disableSubmit = false;
        this.$q.loading.hide();
      }
    },



  }




}







</script>